import { MenuContext } from '@ih/app/client/shared/interfaces';

export class SetMenuContexts {
  public static readonly type = '[Menu] SetMenuContexts';
  constructor(public readonly menuContexts: MenuContext[] | null) {}
}
